/*
 * referral (zod)
 */
import { createInsertSchema, createSelectSchema } from "drizzle-zod"
import * as z from "zod"
import { globalCreateExclude, globalUpdateExclude } from "../utils/constants"
import { referrals } from "./referral.schema"

/* Select */
export type Referral = z.infer<typeof selectReferralSchema>
export const selectReferralSchema = createSelectSchema(referrals)

/* Filters */
export type ReferralFilters = z.infer<typeof referralFiltersSchema>
export const referralFiltersSchema = z.object({
	id: z.string().optional(),
	companyName: z.string().optional(),
	active: z.boolean().optional(),
})

/* Create */
export const createReferralSchema = createInsertSchema(referrals, {
	companyName: z.string().min(1, "Company name is required"),
}).partial(globalCreateExclude)
export type CreateReferral = z.infer<typeof createReferralSchema>

/* Update */
export const updateReferralSchema = createInsertSchema(referrals)
	.omit(globalUpdateExclude)
	.partial()
	.required({ id: true })
export type UpdateReferral = z.infer<typeof updateReferralSchema>
